<template>
  <div>
    <v-navigation-drawer
      v-if="isLoggedIn"
      color="secondary"
      style="font-color: white;"
      v-model="drawer"
      app
      floating
    >
      <!-- Title -->
      <v-list-item class="mt-2 mb-2">
        <v-list-item-content>
          <v-list-item-title class="font-bold text-accent">
            <img src="./assets/mr-prickles.png" />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Divider -->
      <v-divider class="mb-2"></v-divider>
      <!-- Sidebar Items -->
      <v-list dense>
        <div
          v-for="item in items"
          :key="item.title"
        >
          <v-list-group
            v-if="item.items"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon class="mr-4">
                <v-icon small
                  :color="item.active ? 'white': 'accent'"
                >{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <span
                  class="text-sm"
                  :class="{ 'white--text': item.active, 'text-accent': !item.active }"
                >
                  {{ item.title }}
                </span>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="subItem in item.items"
              :key="subItem.title"
              class="mx-0 pl-14"
              :class="{ 'highlight': subItem.active }"
              @click="() => redirect(subItem)"
            >
              <v-list-item-content>
                <div v-if="subItem.heading">
                  {{ subItem.title }}
                  <v-divider></v-divider>
                </div>
                <router-link
                  class="text-sm"
                  :class="{ 'white--text': subItem.active, 'text-accent': !subItem.active }"
                  :to="subItem.to"
                >
                  {{ subItem.title }}
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            class="mx-0"
            :class="{ 'highlight': item.active }"
            @click="() => redirect(item)"
          >
            <v-list-item-icon class="mr-4">
              <v-icon small
                :color="item.active ? 'white': 'accent'"
              >{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <router-link
                class="text-sm"
                :class="{ 'white--text': item.active, 'text-accent': !item.active }"
                :to="item.to"
              >
                {{ item.title }}
              </router-link>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <Version />
    </v-navigation-drawer>
    <v-toolbar>
      <v-app-bar-nav-icon @click="drawer = !drawer"
      v-if="isLoggedIn" />
      <v-toolbar-title>Prickles</v-toolbar-title>
      <v-subheader v-if="isLoggedIn" >
        <v-breadcrumbs
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-subheader>
      <v-spacer></v-spacer>
      <BudgetSwitcher v-if="isLoggedIn" />
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable no-param-reassign */
import BudgetSwitcher from './components/BudgetSwitcher.vue';
import Version from './components/Version.vue';

export default {
  components: {
    BudgetSwitcher,
    Version,
  },
  props: {
    // Navbar title
    title: {
      type: String,
      required: false,
      default: () => 'Prickles',
    },
    // Items which is displayed on at the left side of the Sidebar
    items: {
      type: Array,
      required: false,
      default: () => [
        {
          active: true,
          icon: 'mdi-home',
          title: 'Home',
          to: '/',
        },
        {
          active: false,
          icon: 'mdi-movie',
          title: 'Movies',
          to: '/movies',
        },
        {
          active: false,
          icon: 'mdi-stamper',
          title: 'Budgets',
          to: '/category-codes',
        },
        {
          active: false,
          icon: 'mdi-account-group',
          title: 'Crew',
          to: '/employees',
        },
        {
          active: false,
          icon: 'mdi-file',
          title: 'Documents',
          to: '/documents',
        },
        // {
        //   active: false,
        //   icon: 'mdi-playlist-check',
        //   title: 'Transactions',
        //   to: '/documents/transactions',
        // },
        {
          active: false,
          icon: 'mdi-cash-multiple',
          title: 'Expenses',
          to: '/expenseDocuments',
        },
        {
          active: false,
          icon: 'mdi-file-chart',
          title: 'Budget Reports',
          items: [
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Summary Report',
              to: '/reports/summary',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Budget Variance Report',
              to: '/reports/budget-variance',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Cost Report',
              to: '/reports/prickles3',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Watch List Report',
              to: '/reports/watch-list',
            },
          ],
        },
        {
          active: false,
          icon: 'mdi-file-chart',
          title: 'Crew Reports',
          items: [
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Crew Petty Cash Report',
              to: '/reports/crew-petty-cash',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Crew Timesheet Invoices Report',
              to: '/reports/crew-timesheet-invoice',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Basic Hours Report',
              to: '/reports/basic-hours',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Hours Variance Report',
              to: '/reports/hours-variance',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Per Diem Report',
              to: '/reports/per-diem',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Spend per Person Report',
              to: '/reports/spend-per-person',
            },
          ],
        },
        {
          active: false,
          icon: 'mdi-file-chart',
          title: 'MFC Reports',
          items: [
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'MFC Documents',
              to: '/reports/mfc-documents',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'MFC Report',
              to: '/reports/mfc',
            },
          ],
        },
        {
          active: false,
          icon: 'mdi-file-chart',
          title: 'System Reports',
          items: [
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Bill Payments Recon',
              to: '/reports/xero-recon-bill-payment',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Missing Documents Report',
              to: '/reports/missing-documents',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'MFC Exceptions',
              to: '/reports/mfc-exception',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Recon Report',
              to: '/reports/recon',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Rotation Number Exceptions',
              to: '/reports/rotation-number-exception',
            },
            {
              active: false,
              icon: 'mdi-file-chart',
              title: 'Xero Recon Report',
              to: '/reports/xero-recon',
            },
          ],
        },
        {
          active: false,
          icon: 'mdi-settings',
          title: 'Admin',
          items: [
            {
              active: false,
              icon: 'mdi-settings',
              title: 'Category Codes Settings',
              to: '/category-codes-settings',
            },
            {
              active: false,
              icon: 'mdi-settings',
              title: 'Document Statuses',
              to: '/settings/document-statuses',
            },
            {
              active: false,
              icon: 'mdi-cloud-upload',
              title: 'Imports',
              to: '/imports',
            },
            {
              active: false,
              icon: 'mdi-settings',
              title: 'MFC Codes',
              to: '/settings/mfc-codes',
            },
            {
              active: false,
              icon: 'mdi-settings',
              title: 'Unit of Measure',
              to: '/settings/uom',
            },
          ],
        },
      ],
    },
  },
  watch: {
    $route(to) {
      this.highlightMenuItem(to.path);
    },
  },
  computed: {
    ...mapGetters('app', ['isLoggedIn']),
    breadcrumbs() {
      const result = [{
        text: 'Home',
        disabled: true,
        href: '/',
      }];
      // const activeItem = this.items.find((i) => i.active);
      // if (activeItem.to !== '/') {
      //   result[0].disabled = false;
      //   result.push({
      //     text: activeItem.title,
      //     disabled: true,
      //     href: activeItem?.to,
      //   });
      // }
      return result;
    },
  },
  data() {
    return {
      drawer: true,
    };
  },
  mounted() {
    this.highlightMenuItem(this.$router.history.current.path);
  },
  methods: {
    // Highlight active element
    highlightMenuItem(path) {
      this.items.forEach((i) => {
        if (i.items) {
          i.items.forEach((subItem) => {
            if (subItem?.to === path) {
              subItem.active = true;
            } else {
              subItem.active = false;
            }
          });
        }
        if (i.to === path) {
          i.active = true;
        } else {
          i.active = false;
        }
      });
    },
    // Method is invoked when user click on navigation item
    redirect(item) {
      /** Triggered when user input something in search bar
      * @event action:redirect
      * @type {Object}
      */
      this.$emit('action:redirect', item);
    },
  },
};
</script>

<style lang="scss">
.highlight {
  background-color: lighten(#327D23, 5%)!important
}
.mdi-chevron-down {
  color: #3a9129 !important;
}
.v-navigation-drawer__content .v-list-item__title {
  color: #3a9129;
  font-size: 25px;
}
.v-navigation-drawer__content .v-list .text-accent {
  color: #ccde9d;
  padding-top: 2px;
}
.v-navigation-drawer a {
  text-decoration: none;
}
</style>
